import { render, staticRenderFns } from "./imageData.vue?vue&type=template&id=67638866&"
import script from "./imageData.vue?vue&type=script&lang=js&"
export * from "./imageData.vue?vue&type=script&lang=js&"
import style0 from "./imageData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports